import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Highcharts from 'highcharts';
import { useEventHub } from '@pwc/event-hub-ui';
import useAppTitle from '../common/hooks/useAppTitle';
import { getFooterThunk } from '../common/redux/termsAndConditions/getFooterThunk';
import AppLayout from './AppLayout';
import RouteChangeFocusResetter from './RouteChangeFocusResetter';

export const App = () => {
  window.Highcharts = Highcharts;
  const isInIframe = window.self !== window.top;
  const dispatch = useDispatch();
  const location = useLocation();
  const { eventHub } = useEventHub();

  const title = useAppTitle();
  useEffect(() => {
    document.title = title;
    const topOfPage = document.getElementById('top-of-page');
    topOfPage.textContent = `${title}: Top Of Page`;
  }, [title]);

  useEffect(() => {
    sessionStorage.removeItem('isCommentHighlightsOn');
    // TODO: Update it, if there is multiple calls when Comment panel is not opened
    eventHub?.publish('@commenting-show-comment-threads', false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    dispatch(getFooterThunk());
  }, [dispatch]);

  if (isInIframe) {
    return <span style={{ color: 'red' }}>App cannot be run in an iFrame</span>;
  }

  return (
    <>
      <React.Suspense fallback="Loading...">
        <AppLayout />
        <RouteChangeFocusResetter />
      </React.Suspense>
    </>
  );
};
